export const compensatoryTimeListRoute = {
    path: "/compensatory-time",
    name: "compensatory-time-list",
    component: () => import("../ui/compensatory-time/compensatory-time-list.vue")
};